import React, { FC, useEffect } from 'react';
import { Col, Row, Skeleton } from 'antd';
import { WarningCircle } from 'common/svg';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getMonitorSalesProductRatioModel } from 'app/store/reducers/monitorSales.reducer';
import { IMonitorSalesParams, IMonitorSalesProductRatioSide } from 'entities/MonitorSales/MonitorSales.models';

const formatKey = (key: string) =>
  key
    .split('/')
    .map((part) => (part.length <= 2 ? part.toUpperCase() : part[0].toUpperCase() + part.slice(1).toLowerCase()))
    .join('/');

const RatioSide: FC<{ side: IMonitorSalesProductRatioSide }> = ({ side }) => (
  <Row align="middle" gutter={12}>
    <Col>
      <div className="mb-2 ms-ratio__name">{formatKey(side.key)}</div>
      <div className="ms-ratio__count">{side.count}</div>
    </Col>
  </Row>
);

interface IComponentProps {
  params?: IMonitorSalesParams;
}

// eslint-disable-next-line react/no-multi-comp
export const ProductRatioBlock: FC<IComponentProps> = ({ params }) => {
  const dispatch = useAppDispatch();
  const { monitorSalesProductRatioModel, monitorSalesProductRatioModelLoading } = useAppSelector(
    (state) => state.monitorSales
  );

  useEffect(() => {
    dispatch(getMonitorSalesProductRatioModel(params));
  }, [params?.storeCode, params?.week]);

  const ratios = monitorSalesProductRatioModel?.ratios ?? [];

  return (
    <div className="ms-block">
      <div className="ms__header">
        <span className="ff-medium fs-xs">Product Ratio</span>
        <WarningCircle />
      </div>

      <div className="ms__body">
        {monitorSalesProductRatioModelLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} title={false} />
        ) : (
          <div className="ms-ratio__container">
            {ratios.map((item, index) => (
              <Row key={index} justify="space-between" align="middle">
                <Col span={7}>
                  <RatioSide side={item.left} />
                </Col>
                <Col span={4}>
                  <span className="color-gray-1">=</span>
                </Col>
                <Col span={13}>
                  <RatioSide side={item.right} />
                </Col>
              </Row>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
